module.exports = __webpack_public_path__ + "media/images/benefits-modal-6e7eed1fc2d5f54773448169a3e7dc09.jpg";